// extracted by mini-css-extract-plugin
export var phone = "_4i-0";
export var phoneDragging = "_4i-1";